import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ContactSection from './pages/ContactSection';
import AboutUs from './pages/AboutUs';
import BecomeMember from './pages/BecomeMember';
import Volunteer from './pages/Volunteer';
import Donate from './pages/Donate';
import StoriesPage from './pages/StoriesPage';
import AdminLogin from './components/AdminLogin';
import DashboardHome from './dashboard/DashboardHome';
import SessionGuard from './dashboard/SessionGuard';
import MemberList from './dashboard/MemberList';
import VolunteerList from './dashboard/VolunteerList';
import DonationList from './dashboard/DonationList';
import BlogManagement from './dashboard/BlogManagement';
import ChangePassword from './dashboard/ChangePassword';
import NotificationsPage from './dashboard/NotificationsPage';
import EventsPage from './dashboard/EventsPage';
import TestimonialsPage from './dashboard/TestimonialsPage';
// Add more as needed
import CoreTeam from './pages/CoreTeam';
import Mentors from './pages/Mentors';
import Education from './pages/Education';
import Environment from './pages/Environment';
import WomenEmpowerment from './pages/WomenEmpowerment';
import Health from './pages/Health';
import PrivacyPolicy from './pages/Privacy_Policy'
import NotFound from './pages/NotFound';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Layout from "./components/Layout";

// प्लेसहोल्डर पेज
const Contact: React.FC = () => <ContactSection />;

const Home: React.FC = () => {
  return <HomePage />;
};

const App: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          {/* Admin login is intentionally outside the public SEO layout. */}
          <Route path="/admin/*" element={<AdminLogin />} />
          <Route element={<Layout />}>
            <Route path="/" element={<><Header /><Home /><Footer /></>} />
          <Route path="/about/" element={<><Header /><AboutUs /><Footer /></>} />
            <Route path="/media/" element={<Navigate to="/" replace />} />
            <Route path="/donate" element={<Navigate to="/donate/" replace />} />
            <Route path="/volunteer" element={<Navigate to="/volunteer/" replace />} />
            <Route path="/certification" element={<Navigate to="/" replace />} />
            <Route path="/team" element={<Navigate to="/" replace />} />
            <Route path="/blogs/" element={<Navigate to="/stories/" replace />} />
            <Route path="/stories/" element={<><Header /><StoriesPage /><Footer /></>} />
            <Route path="/contact/" element={<><Header /><Contact /><Footer /></>} />
            <Route path="/become-member/" element={<><Header /><BecomeMember /><Footer /></>} />
            <Route path="/volunteer/" element={<><Header /><Volunteer /><Footer /></>} />
            <Route path="/donate/" element={<><Header /><Donate /><Footer /></>} />
            <Route element={<SessionGuard />}>
            <Route path="/dashboard" element={<DashboardHome />} />
            <Route path="/dashboard/members" element={<MemberList />} />
            <Route path="/dashboard/volunteers" element={<VolunteerList />} />
            <Route path="/dashboard/donations" element={<DonationList />} />
            <Route path="/dashboard/blogs" element={<BlogManagement />} />
            <Route path="/dashboard/change-password" element={<ChangePassword />} />
            <Route path="/dashboard/notifications" element={<NotificationsPage />} />
            <Route path="/dashboard/events" element={<EventsPage />} />
            <Route path="/dashboard/testimonials" element={<TestimonialsPage />} />
            </Route>
            {/* Add more dashboard routes as needed */}
            <Route path="/core-team/" element={<><Header /><CoreTeam /><Footer /></>} />
            <Route path="/mentors/" element={<><Header /><Mentors /><Footer /></>} />
            <Route path="/education/" element={<><Header /><Education /><Footer /></>} />
            <Route path="/women-empowerment/" element={<><Header /><WomenEmpowerment /><Footer /></>} />
            <Route path="/environment/" element={<><Header /><Environment /><Footer /></>} />
            <Route path="/health/" element={<><Header /><Health /><Footer /></>} />
            <Route path="/livelihood/" element={<Navigate to="/" replace />} />
            <Route path="/privacy-policy/" element={<><Header /><PrivacyPolicy /><Footer /></>} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </div>
    </Router>
  );
};

export default App;
